/* istanbul ignore file */
// eslint-disable-next-line nebula-rules/check-exist-test-file
export const getIsDevMode = () => typeof window !== 'undefined' && !!sessionStorage.getItem('_a');
